import React, { useState, useRef, useEffect } from 'react';
import Header from '../components/HeaderComponent';
import IntroComponent from '../components/IntroComponent';
import BenefitsComponent from '../components/BenefitsComponent';
import PlanSelectionComponent from '../containers/PlanSelectionComponent';
import FooterComponent from '../components/FooterComponent';
import '../assets/css/main.css';
import { BENEFITS } from '../assets/shared/benefits';
import useDataStore from '../store/dataStore';


function HomePageComponent() {
  const [source, setSource] = useState(localStorage.getItem("source"));
  const [benefits, setBenefits] = useState(BENEFITS);
  const myRef = useRef(null);
  const configData = useDataStore((state) => state.data);

  const handleChange = (event) => {
    executeScroll();
  };

  const executeScroll = () => {
    myRef.current.scrollIntoView();
  };

  useEffect(() => {
    setSource(localStorage.getItem("source"));
  }, []);

  return (
    <div className="HomePage">
      <Header />
      <IntroComponent handleChange={handleChange} />
      <div ref={myRef}>
        <PlanSelectionComponent />
      </div>
      {!configData.benefits.showBenefitsSection ? (
        <div className='nobenifits_bar'></div>
      ) : (
        <BenefitsComponent benefits={benefits} />
      )}
      {configData.tnc.Footer && <FooterComponent />}
    </div>
  );
}

export default HomePageComponent;
